import { render, staticRenderFns } from "./ExpertizePropertyAddNew.vue?vue&type=template&id=6a5999aa&scoped=true&"
import script from "./ExpertizePropertyAddNew.vue?vue&type=script&lang=js&"
export * from "./ExpertizePropertyAddNew.vue?vue&type=script&lang=js&"
import style0 from "./ExpertizePropertyAddNew.vue?vue&type=style&index=0&id=6a5999aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5999aa",
  null
  
)

export default component.exports